export default "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='124'%20height='122.643'%20viewBox='0%200%20124%20122.643'%3e%3c/svg%3e"